import { gettext } from '@eventbrite/i18n';
import loadable from '@loadable/component';
import React from 'react';
import { lookUpUserAction } from '../../actions/lookup';
import FormDivider from '../../components/common/FormDivider';
import LookupForm from '../../components/forms/LookUpForm';
import { IAllContextsProps } from '../../constants/interfaces';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    shouldAllowHeader,
    shouldAllowNotifications,
} from '../../utils/conditionals';
import { useModals } from '../hooks/modalHooks';
import SocialLoginOptions from '../socialLoginOptions/SocialLoginOptions';

const Lookup = ({ routing }: { routing?: any }) => {
    const configContext: IConfigContextProps = useConfigContext();
    const modal = useModals();

    let contentHeader = null;
    if (shouldAllowHeader(configContext)) {
        const Header = loadable(() => import('../../components/common/Header'));
        contentHeader = (
            <Header
                titleText={
                    configContext.header?.titleText ??
                    gettext('Create an account')
                }
                subtitleText={configContext.header?.subtitleText}
                headerLinkProps={configContext.header?.headerLinkProps}
            />
        );
    }

    let contentNotification = null;
    if (shouldAllowNotifications(configContext)) {
        const Notifications = loadable(
            () => import('../../components/common/Notifications'),
        );

        contentNotification = <Notifications section="signup" />;
    }

    return (
        <>
            {contentHeader}

            {contentNotification}

            <LookupForm
                onSubmit={({
                    values,
                    contexts,
                }: {
                    values: { email: string };
                    contexts: IAllContextsProps;
                }) => {
                    lookUpUserAction({
                        data: values,
                        isSignup: true,
                        contexts,
                    });
                }}
                buttonCTA={
                    configContext.signupMethods?.submitButtonText?.lookup ??
                    gettext('Continue')
                }
                shouldAnimate={false}
            />

            {modal}

            <FormDivider />

            <div className="eds-l-pad-bot-5" data-testid="social-login-section">
                <SocialLoginOptions routing={routing} isSignupFlow={true} />
            </div>
        </>
    );
};

export default Lookup;
